import React, { useContext, useEffect, useState } from "react";
import { ShopContext } from "../context/ShopContext";
import { generateRandomPurchase } from "./generateRandomPurchases";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

const CARD_INTERVAL = 0.1 * 60 * 1000; // 3 minutes

const Column = ({ purchase }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/product/${purchase.product._id}`);
  };

  return (
    <motion.div
      key={purchase.timeAgo + purchase.buyer}
      initial={{ y: 150, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -150, opacity: 0 }}
      transition={{ duration: 0.6 }}
      onClick={handleCardClick}
      className="bg-white shadow-md rounded-lg flex items-center gap-4 p-4 h-[110px] w-full cursor-pointer hover:shadow-lg transition-shadow"
    >
      <img
        src={purchase.photo || purchase.product.image[0]}
        alt={purchase.product.name}
        className="w-16 h-16 object-cover rounded"
      />
      <div>
        <p className="text-sm text-gray-600">
          <span className="font-semibold">{purchase.buyer}</span> in{" "}
          <span className="font-semibold">{purchase.location}</span> purchased
        </p>
        <p className="font-semibold text-black truncate w-44">{purchase.product.name}</p>
        <p className="text-green-600 text-sm mt-1">{purchase.timeAgo}</p>
      </div>
      <button className="text-green-700 text-sm font-medium ml-auto">VIEW</button>
    </motion.div>
  );
};

const RecentPurchases = () => {
  const { products } = useContext(ShopContext);

  const [column1, setColumn1] = useState(null);
  const [column2, setColumn2] = useState(null);
  const [column3, setColumn3] = useState(null);

  useEffect(() => {
    if (products.length === 0) return;

    const updateAll = () => {
      setColumn1(generateRandomPurchase(products));
      setColumn2(generateRandomPurchase(products));
      setColumn3(generateRandomPurchase(products));
    };

    updateAll(); // initial load

    const interval = setInterval(updateAll, CARD_INTERVAL);

    return () => clearInterval(interval);
  }, [products]);

  return (
    <div className="py-8 px-4">
      <h2 className="text-center text-2xl font-bold mb-6">RECENT PURCHASES</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 justify-center max-w-[1000px] mx-auto">
        {[column1, column2, column3].map((purchase, i) => (
          <div key={i} className="relative h-[110px] overflow-hidden w-full">
            <AnimatePresence mode="wait">
              {purchase && <Column purchase={purchase} />}
            </AnimatePresence>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentPurchases;
